export enum AppNotificationType {
  ExportJob = 0,
  DueDateReminder = 1,
  Sla = 2,
  WorkflowStep = 3,
  LicenseNotification = 4,
  MergeJob = 5,
  BulkWorkflowAction = 6,
  EntryBulkAction = 7,
  FormUsedInVisualization = 8,
  ProcessFlowSendNotification = 9,
  UserMentionNotification = 10,
  Message = 11,
  DownloadApp = 12,
}
